import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";

const NotFound = lazy(() => import("./pages/NotFound"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const DataManagementService = lazy(() => import("./pages/DataManagementService"));
const CustomDashboardsService = lazy(() => import("./pages/CustomDashboardsService"));
const WebsiteDesignService = lazy(() => import("./pages/WebsiteDesignService"));
const BrandIdentityService = lazy(() => import("./pages/BrandIdentityService"));
const LogoDesignService = lazy(() => import("./pages/LogoDesignService"));
const DataAnalyticsService = lazy(() => import("./pages/DataAnalyticsService"));
const AutomationService = lazy(() => import("./pages/AutomationService"));
const AIAutomationService = lazy(() => import("./pages/AIAutomationService"));
const ExcelTrainingService = lazy(() => import("./pages/ExcelTrainingService"));

function RouteFallback() {
  return <div className="min-h-screen bg-[#111827]" aria-label="Loading page" />;
}

function Router() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/services/data-management" component={DataManagementService} />
        <Route path="/services/custom-dashboards" component={CustomDashboardsService} />
        <Route path="/services/website-design" component={WebsiteDesignService} />
        <Route path="/services/brand-identity" component={BrandIdentityService} />
        <Route path="/services/logo-design" component={LogoDesignService} />
        <Route path="/services/data-analytics" component={DataAnalyticsService} />
        <Route path="/services/automation" component={AutomationService} />
        <Route path="/services/ai-automation" component={AIAutomationService} />
        <Route path="/services/excel-training" component={ExcelTrainingService} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-of-service" component={TermsOfService} />
        <Route path="/404" component={NotFound} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <Toaster />
        <Router />
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
